import { Space, DefaultTheme } from "../shared";
import { getGap } from "./getGap";

export const getNegativeMargin = (theme: DefaultTheme) => (gap?: keyof typeof Space | null) =>
  `calc(-${getGap(theme)(gap)}/2)`;
